import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
  CLASS_TYPES,
  EditSbatGroupForm,
  EditSbatGroupAcademyTopicForm,
  parseAcademyTopicClassType,
  setSelectedRescheduleSbatGroup,
  useGetSbatGroupQuery,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import EditSbatGroupContestForm from './EditSbatGroupContestForm';
import EditSbatGroupLectureForm from './EditSbatGroupLectureForm';
import EditSbatGroupSuperBatchesForm from './EditSbatGroupSuperBatchesForm';
import EditSbatGroupWithoutLiveLectureForm from './EditSbatGroupWithoutLiveLectureForm';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import RescheduleReasonModal from './RescheduleReasonModal';
import SbatGroupNudgeMessage from './SbatGroupNudgeMessage';
import SectionHeading from 'components/SectionHeading';

const EDIT_CLASS_FORM_MAP = {
  [CLASS_TYPES.lecture]: EditSbatGroupLectureForm,
  [CLASS_TYPES.contest]: EditSbatGroupContestForm,
  [CLASS_TYPES.classWithoutLiveLecture]: EditSbatGroupWithoutLiveLectureForm,
};

export default function EditSbatGroupPage() {
  const dispatch = useDispatch();
  const { sbatGroupId } = useParams();
  const { isLoading, isFetching, error, data, refetch } = useGetSbatGroupQuery(
    Number(sbatGroupId)
  );

  useEffect(() => {
    if (data?.data) {
      dispatch(setSelectedRescheduleSbatGroup(data?.data));
    }
  }, [data?.data, dispatch]);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load Class Details"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const sbatGroup = data?.data;
    const academyTopic = sbatGroup.academy_topic;
    const classTag = data?.meta?.['class_tag'];

    const classType = parseAcademyTopicClassType(academyTopic);
    const EditClassFormComponent = EDIT_CLASS_FORM_MAP[classType];

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <RescheduleReasonModal />
        <SectionHeading
          title="EDIT CLASS"
          subtitle="Fill in the following details to edit the selected class"
        />
        <SbatGroupNudgeMessage sbatGroup={sbatGroup} />
        <EditableSection
          canEdit
          title="Lecture Activity"
          titleClassName="dark bold"
          className="m-b-s"
        >
          {(editableProps) => (
            <EditSbatGroupAcademyTopicForm
              {...editableProps}
              sbatGroup={sbatGroup}
            />
          )}
        </EditableSection>
        <EditableSection
          canEdit
          title="Batch/es"
          titleClassName="dark bold"
          className="m-b-s"
        >
          {(editableProps) => (
            <EditSbatGroupSuperBatchesForm
              {...editableProps}
              sbatGroup={sbatGroup}
            />
          )}
        </EditableSection>
        <EditableSection
          canEdit
          title="Date And Time"
          titleClassName="dark bold"
          className="m-b-s"
        >
          {(editableProps) => (
            <EditSbatGroupForm
              {...editableProps}
              sbatGroup={sbatGroup}
            />
          )}
        </EditableSection>
        {EditClassFormComponent && (
          <EditClassFormComponent
            sbatGroup={sbatGroup}
            classTag={classTag}
          />
        )}
      </>
    );
  }
}
